<span (click)="editProduct()" class="dots">
  <svg height="13" viewBox="0 0 3 13" width="3"
       xmlns="http://www.w3.org/2000/svg">
   <g data-name="Gruppe 308" id="Gruppe_308" transform="translate(-305 -554)">
     <circle cx="1.5" cy="1.5" data-name="Ellipse 46" fill="#333" id="Ellipse_46"
             r="1.5"
             transform="translate(305 554)"/>
     <circle cx="1.5" cy="1.5" data-name="Ellipse 47" fill="#333" id="Ellipse_47"
             r="1.5"
             transform="translate(305 559)"/>
     <circle cx="1.5" cy="1.5" data-name="Ellipse 48" fill="#333" id="Ellipse_48"
             r="1.5"
             transform="translate(305 564)"/>
   </g>
 </svg>
</span>

<div *ngIf="cartItem" [ngClass]="{'open': editProductOpen}" class="product-edit">
  <div class="counter shrink flex-container align-center">
    <div (click)="quantityDown()" class="minus shrink">
      <svg data-name="Gruppe 331" height="4.742" id="Gruppe_331"
           viewBox="0 0 14.295 4.742" width="14.295" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <clipPath id="clip-path">
            <rect data-name="Rechteck 113" fill="#333" height="4.742" id="Rechteck_113" width="14.295"/>
          </clipPath>
        </defs>
        <g clip-path="url(#clip-path)" data-name="Gruppe 330" id="Gruppe_330">
          <path d="M13.645,3.477H.65a.65.65,0,0,1,0-1.3h13a.65.65,0,0,1,0,1.3" data-name="Pfad 159"
                fill="#333" id="Pfad_159"
                transform="translate(0 1.265)"/>
        </g>
      </svg>
    </div>
    <div class="count shrink">
      {{ quantity }}
    </div>
    <div (click)="quantityUp()" class="plus shrink">
      <svg height="14.293" viewBox="0 0 14.295 14.293" width="14.295"
           xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <clipPath id="clip-path">
            <rect data-name="Rechteck 112" fill="#333" height="14.293" id="Rechteck_112" width="14.295"/>
          </clipPath>
        </defs>
        <g clip-path="url(#clip-path)" data-name="Gruppe 328" id="Gruppe_328">
          <path d="M13.645,6.5H7.8V.65a.65.65,0,1,0-1.3,0V6.5H.65a.65.65,0,0,0,0,1.3H6.5v5.847a.65.65,0,1,0,1.3,0V7.8h5.847a.65.65,0,0,0,0-1.3" data-name="Pfad 158"
                fill="#333"
                id="Pfad_158" transform="translate(0 0)"/>
        </g>
      </svg>
    </div>
  </div>
  <a
    (click)="closeCart()"
    [routerLink]="['/collections/collection-detail/' + cartItem.collectionId.toString() + '/product/' + cartItem.productId.toString()]">{{ 'product-edit.product-detail' | i18next}}</a>
  <a (click)="closeCart()"
     [routerLink]="['/collections/collection-detail/' + cartItem.collectionId.toString()]">{{ 'product-edit.collection-detail' | i18next}}</a>
  <div (click)="remove(cartItem)" class="btn primary full delete">{{ 'product-edit.delete-product' | i18next}}</div>
</div>
